import './src/ui/global.css'
import * as React from 'react'
import type { GatsbyBrowser } from 'gatsby'
import { App } from './src/app'

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return <App>{element}</App>
}
